import { Component, ViewChild } from '@angular/core';
import { NavController,  ViewController, Config,Content, ActionSheet, ActionSheetController} from 'ionic-angular';

import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';
import { UserMyRadiant as User, RepositoryMyRadiant, HelperMyRadiant } from '../../../../providers';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { FileChooser } from '@ionic-native/file-chooser';
import { Base64 } from '@ionic-native/base64';
import { FilePath } from '@ionic-native/file-path';
import { File } from '@ionic-native/file';
import { Api } from '../../../../providers/api/api';
import { Utility } from '../../../../providers/resources/utility';

@Component({
  selector: 'profil-edit',
  templateUrl: 'page.html'
})
export class EditPegawai {
  @ViewChild(Content) content: Content;
  
  loading : any;
  segmentActive: string = "general";
  formOvertime = {
    type:'',
    date:'',
    purpose:'',
  };
  stateRequest = 11;

  inputSelectabel = {
    city:null,
  };

  parameter = {
    id : this.userApi.data.Employee_ID,
    user_code : this.userApi.data.NIK,
    nik: this.userApi.data.NIK,
    token:1,
    user_nik:"",
    flag_data:"last",
  };


  data = {
    last_general:{},
    general:{},
    family:[],
    city:[],
    medical:[],
    medical_last:[],
    insurance_last:[],
    certificate_last:[],
    insurance:[],
    certificate:[],
    religion:[],
    relationship:[],
    preview_img:"./assets/img/no_img.jpg",
    StatusMCU : [],
    PaketMCU : [],
    TypeMCU : [],
  };
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public actionSheetCtrl    : ActionSheetController,
    public camera             : Camera,
    public file               : File, 
    private fileChooser       : FileChooser,
    private base64            : Base64,
    private filepath          : FilePath,
    private utility           : Utility
  ) {
    this.config.set('backButtonText','Edit Identity'); 
    this.loading = this.helper.showLoading("Please Wait..");
    this.getFamily();
    this.getGeneral();
    this.getReligion();
    this.getCity();
    this.getPaketMCU();
    this.getTypeMCU();
    this.getStatusMCU();
    this.getRelationship();
    this.getMedical();
    this.getInsurance();
    this.getCeritificate();
  }

  expandSegment(evt,segment): void {
    this.segmentActive = segment;
  }
  collapseSegment(evt,segment){1
    this.segmentActive = 'none';
  }
  
  setFile(url){
    let me = this;
    this.filepath.resolveNativePath(url).then(imageData => {
      me.data.preview_img = imageData;
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {
        me.data.general['foto'] = file.name;
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {
        me.data.general['foto_binary'] = base64File;
      }, (err) => {
        console.log(err);
      });
    })
    .catch(err => console.log(err));
  }

  showCamera(){
    let me = this;
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum:true,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection:this.camera.Direction.FRONT
    }
    
    this.camera.getPicture(options).then((uri) => {
      this.setFile(uri);
      
    }, (err) => {
     // Handle error
    });
  }

  chooseFile(){
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.setFile(uri);
      })
      .catch(e => console.log(e));
  }

  changeFoto(){
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Change Photo',
      buttons: [
        {
          text: 'Use Camera',
          // role: 'destructive',
          handler: () => {
            this.showCamera();
          }
        },
        {
          text: 'Upload Photo',
          handler: () => {
            this.chooseFile();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
 
    actionSheet.present();
  }

  togleSegment(content,active){
    console.log(content,active);
    if(content == active){
      this.collapseSegment(null,content);
    }else{
      this.expandSegment(null,content);
    }
  }

  // getReligion(){
  //   let me = this;
  //   this.loading = this.helper.showLoading("Please Wait..");
  //   this.repositoryProvider.getProfilTicket(this.parameter).subscribe((resp:any) => {
  //     this.stateRequest = this.stateRequest - 1;
  //     if(this.stateRequest == 0){
  //       try {
  //         this.loading.dismiss();
  //       } catch (error) {
          
  //       }
  //     }
  //     if(resp.success){
  //       resp.data.forEach(row => {
          
  //       });
  //     }
  //   },(err) => {
  //     this.helper.presentToast('Error');
  //     try {
  //       this.loading.dismiss();
  //     } catch (error) {
        
  //     }
  //   }); 
  // }

  getGeneral(){
    let me = this;
    this.repositoryProvider.getProfilGeneral(this.parameter).subscribe((resp:any) => {
    this.stateRequest = this.stateRequest - 1;
    if (this.stateRequest == 0) {
      try {
        this.loading.dismiss();
      } catch (error) {
      }
    }
      if(resp.success){
       resp.data.idnumber  = resp.data.code;
       resp.data.jabatan   = resp.data.Jabatan;
       resp.data.division  = resp.data.division_name;
       me.data.preview_img = me.utility.getFolderUpload_server() + resp.data.foto;
       if (resp.data.hrm_city_id != null && resp.data.hrm_city_id!=undefined) {
        me.inputSelectabel.city = {
          id:resp.data.hrm_city_id,
          name:resp.data.city
        };
       }
        localStorage.setItem('last_general',JSON.stringify(resp.data));
        me.data.general = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getFamily(){
    let me = this;
    this.repositoryProvider.getProfilFamily(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        localStorage.setItem('last_family',JSON.stringify(resp.data));
        me.data.family = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getRelationship(){
    let me = this;
    this.repositoryProvider.getListRelationship().subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        this.data.relationship = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getCity(){
    let me = this;
    this.repositoryProvider.getListCity().subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        this.data.city = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getReligion(){
    let me = this;
    this.repositoryProvider.getListReligion().subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
        }
      }
      if(resp.success){
        this.data.religion = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  addMyFamily(){
    let newFamily = {
      active_sts: null,
      create_stamp: null,
      date_of_birth: null,
      delete_stamp:null,
      gender: null,
      general_info:null,
      guid:null,
      hrm_employee_creator_id: null,
      hrm_employee_id: null,
      hrm_employee_modifier_id: null,
      hrm_family_relationship_id: null,
      hrm_gender_id: null,
      hrm_religion_id: null,
      id: null,
      name: null,
      place_of_birth:null,
      relationship: null,
      religion: null,
      ttl:null,
      state:"new",
      update_stamp: null,
    }
    this.data.family.push(newFamily);
    setTimeout(() => {
      this.content.scrollToBottom();
    }, 1000);
  }

  checkGender(val,flag){
    if (flag == "male" && val==1) {
      return "checked";
    }else if(flag == "female" && val==2) {
      return "checked";
    }else {
      return false;
    }
  }

  onChangeCity(obj){
    this.data.general['city'] = obj.value.name;
    this.data.general['hrm_city_id'] = obj.value.id;
    this.inputSelectabel.city = obj.value;
  }

  save(){
    let me = this;
    let new_family = [];
    this.loading = this.helper.showLoading("Processing Data...");

    let index_religion_general = this.helper.findValueFromArrayObject(this.data.religion,'id',this.data.general['hrm_religion_id']);
    if (index_religion_general != -1) {
      this.data.general['agama'] = this.data.religion[index_religion_general]['name'];
    }

    this.data.family.forEach(family => {
      let name_input_gender = family.id+'_gender';
      let state_male = document.getElementsByName(name_input_gender)[0]['checked'];
      let state_female = document.getElementsByName(name_input_gender)[1]['checked'];
      if (state_male) {
        family.hrm_gender_id = 1;
        family.gender = "Male";
      }
      if (state_female) {
        family.hrm_gender_id = 2;
        family.gender = "Female";
      }
      let index_religion = this.helper.findValueFromArrayObject(this.data.religion,'id',family.hrm_religion_id);
      if (index_religion != -1) {
        family.agama = this.data.religion[index_religion]['name'];
      }else{
        family.agama = null;
      }
      let index_relationship = this.helper.findValueFromArrayObject(this.data.relationship,'id',family.hrm_family_relationship_id);
      if (index_relationship != -1) {
        family.relationship = this.data.relationship[index_relationship]['name'];
      }
      if (!state_male && !state_female) {
        family.hrm_gender_id = null;
      }
      if (family.general_info == '-') {
        family.general_info = null;
      }

      new_family.push(family);
    });
    let parameter = {
      last_general : localStorage.getItem('last_general'),
      general : JSON.stringify(this.data.general),
      family : JSON.stringify(new_family),
      last_family : localStorage.getItem('last_family'),
      last_mcu : localStorage.getItem('last_medical'),
      new_mcu : JSON.stringify(this.data.medical),
      last_insurance : localStorage.getItem('last_insurance'),
      new_insurance : JSON.stringify(this.data.insurance),
      last_certificate : localStorage.getItem('last_certificate'),
      new_certificate : JSON.stringify(this.data.certificate),
      
    }
    this.userApi.requestEditEmployee(parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      try {
        this.loading.dismiss();
      } catch (error) {
      }
      if(resp.success){
        this.viewCtrl.dismiss();
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });
    
  }

  removeFamily(index){
    this.data.family.splice(index,1);
  }

  getMedical(){
    let me = this;
    this.repositoryProvider.getProfilMedical(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        localStorage.setItem('last_medical',JSON.stringify(resp.data));
        me.data.medical = resp.data;        
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getInsurance(){
    let me = this;
    // let parameter = {
    //   id:this.parameter.id
    // };
    this.repositoryProvider.getProfilInsurance(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        localStorage.setItem('last_insurance',JSON.stringify(resp.data));
        me.data.insurance = resp.data;        
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getCeritificate(){
    let me = this;
    this.repositoryProvider.getProfilCeritificate(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        localStorage.setItem('last_certificate',JSON.stringify(resp.data));
        me.data.certificate = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getStatusMCU() {
    this.repositoryProvider.getStatusMCU().subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if (this.stateRequest == 0) {
        try {
          this.loading.dismiss();
        } catch (error) {
        }
      }
      this.data.StatusMCU = resp.data;
    });
  }
  getTypeMCU() {
    this.repositoryProvider.getTypeMCU().subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if (this.stateRequest == 0) {
        try {
          this.loading.dismiss();
        } catch (error) {
        }
      }
      this.data.TypeMCU = resp.data;
    });
  }
  getPaketMCU() {
    this.repositoryProvider.getPaketMCU().subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if (this.stateRequest == 0) {
        try {
          this.loading.dismiss();
        } catch (error) {
        }
      }
      this.data.PaketMCU = resp.data;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/profil/edit_profil/page.ts